// extracted by mini-css-extract-plugin
module.exports = {"root":"dropdown-input_root__26VPO"};